import { BookGrid, type BookFilter } from '../components/BookDiscovery'
import { Footer, SiteHeader } from '../components/SiteShell'
import { BOOK_CATEGORIES } from '../data/books'

function requestedCategory(): BookFilter {
  const value = new URLSearchParams(window.location.search).get('category')
  return BOOK_CATEGORIES.includes(value as BookFilter) ? value as BookFilter : 'All'
}

export default function BooksPage() {
  return (
    <>
      <SiteHeader />
      <main className="books-page">
        <section className="books-hero shell">
          <span className="eyebrow">The Lucie’s Book collection</span>
          <h1>Books made<br /><em>just for them.</em></h1>
          <p>Find a story that feels like your child, then make every page wonderfully theirs.</p>
        </section>
        <section className="books-catalog shell" id="books">
          <BookGrid initialCategory={requestedCategory()} syncCategoryToUrl />
        </section>
      </main>
      <Footer />
    </>
  )
}
